/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { unregister } from './ServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

unregister();
